import { Col, Row } from 'antd';
import React from 'react'
import { groupDifferencesByAction, losRateSheetColumns } from './helper';
import { renderModifiedGroup, renderRegularEntry, renderRegularGroup } from './formHelper';
import { Card } from '../../common/UIComponents';
import I18n from '../../common/I18n';

export const RateSheetDetails = ({data}) => {

  const renderEntireGroup = (changes, title, type, columns) => {
    if (!changes?.length) return null;
    return(
      <div>
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        {title}
      </h4>
      <Card
      style={{
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
      }}
      >
        {renderRegularEntry(changes, title, type)}
        {renderRegularGroup(changes, title, type, columns)}
      </Card>
      </div>
    )
  }

  const renderDetails = () => {
    const losRateSheetData = data?.difference[0]?.los_ratesheet ?? [];
    const incomingAction = data?.difference[0]?.los_ratesheet?.[0]?.action;  
    const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference: losRateSheetData });
    const incomingEntry = losRateSheetData[0]?.new_value ? "New Entry" : "Old Entry";
    return (
      <div className="mt-6">
          <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
              <span style={{ fontSize: '20px', color: '#395484' }}>{I18n.t('general.short_los')} Rate Sheet Details</span>
              <div className="mt-6">
                  {renderEntireGroup(groupedDifferences.REMOVED, 'Deleted Entry', 'REMOVED', losRateSheetColumns)}
                  {renderEntireGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED', losRateSheetColumns)}
                  {renderModifiedGroup(groupedDifferences.MODIFIED,losRateSheetColumns)}
              </div>
          </h4>
      </div>
  );
  }

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderDetails()}</Col>
    </Row>
  )
}